import React from 'react';
import { Modal, Form, Input, InputNumber, Select, Row, Col } from 'antd';

const { Option } = Select;

export default function DeviceModal({
  open,
  editingDev,
  form,
  onSave,
  onCancel
}) {
  return (
    <Modal
      title={editingDev ? "Edit Device Settings" : "Register eSSL Biometric K30 Device"}
      open={open}
      onOk={onSave}
      onCancel={onCancel}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item name="device_name" label="Device Display Name" rules={[{ required: true }]}>
          <Input placeholder="e.g. Main Entrance K30" />
        </Form.Item>
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item name="machine_number" label="Device ID / Machine Number" tooltip="Default is 1 (matches Device ID in PC Connection menu)">
              <InputNumber min={1} style={{ width: '100%' }} placeholder="1" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="comm_key" label="COMM Key / Password" tooltip="Default is 0 (matches COMM Key in PC Connection menu)">
              <Input placeholder="0" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={14}>
            <Form.Item name="ip_address" label="IP Address (Optional for LAN)">
              <Input placeholder="e.g. 192.168.1.201" />
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item name="port" label="TCP Port">
              <Input placeholder="4370" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item name="serial_number" label="Serial Number">
          <Input placeholder="e.g. K30-998877" />
        </Form.Item>
        <Form.Item name="location" label="Location / Branch">
          <Input placeholder="Main Gate / Studio Office" />
        </Form.Item>
        <Form.Item name="status" label="Device Status" rules={[{ required: true }]}>
          <Select>
            <Option value="ONLINE">ONLINE</Option>
            <Option value="OFFLINE">OFFLINE</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
}
